import { render, staticRenderFns } from "./CardFarmsAreaController.vue?vue&type=template&id=0ace5006&"
import script from "./CardFarmsAreaController.vue?vue&type=script&lang=ts&"
export * from "./CardFarmsAreaController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports